(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(Debutify.settings.dbtfy_sticky_header == false) return;

      this.defaultColorScheme = "dbtfy-color-"+this.dataset.colorScheme;
      this.defaultCustomColorScheme = "color-"+this.dataset.customColorScheme;
      this.transparentColorScheme = "dbtfy-color-"+this.dataset.transparentHeaderColorScheme;
      this.transparentCustomColorScheme = "color-"+this.dataset.customTransparentHeaderColorScheme;
      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
        this.classList.add('dbtfy-header--transparent');
        this.classList.add(this.transparentColorScheme);
        this.classList.add(this.transparentCustomColorScheme);
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        
        if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
          this.classList.add(this.defaultColorScheme,this.defaultCustomColorScheme);
          if(this.classList.contains("dbtfy-header--transparent")){
            this.classList.remove('dbtfy-header--transparent');
          }
          if(this.transparentColorScheme){
            //this.classList.remove(this.transparentColorScheme);
          }
          if (this.transparentCustomColorScheme) {
            //this.classList.remove(this.transparentCustomColorScheme);
          }
        }
        
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {

        if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
          this.classList.add(this.transparentColorScheme,this.transparentCustomColorScheme,'dbtfy-header--transparent');
          if(this.defaultColorScheme){
            this.classList.remove(this.defaultColorScheme);
          }
          if (this.defaultCustomColorScheme) {
            this.classList.remove(this.defaultCustomColorScheme);
          }
        }

        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notti-crossword"] && !Shopify.designMode) return;
  try {
    
function initNottiCrossword(root){
if (root.dataset.initialized === "true") return;
root.dataset.initialized = "true";
const $ = id => root.querySelector('[data-nx="' + id + '"]');
const ROWS = 10, COLS = 11;
const WORDS = [
  {a:"REVLQUJXT0xT", r:4, c:0, d:"A", clue:"How our signature kibble is made: cooked gently at 90°C", e:"(4-5)"},
  {a:"UElOVEFD",     r:1, c:4, d:"A", clue:"Herb blended with chicken and goat milk in our ActivePlay freeze-dried chunks", e:"(6)"},
  {a:"RUVCU0lSRg==", r:7, c:4, d:"A", clue:"Notti merch made for zooming, leaping and catching at the park", e:"(7)"},
  {a:"VE5FUldBUA==", r:9, c:2, d:"A", clue:"New Dog ___ Kit: our starter bundle for first-time owners", e:"(7)"},
  {a:"VUFNVUFN",     r:0, c:5, d:"D", clue:"What we call cats at Notti", e:"(3,3)"},
  {a:"Tk9NTEFT",     r:0, c:2, d:"D", clue:"Fish that pairs with duck in our Allergy Care kibble", e:"(6)"},
  {a:"Tk9TSU5FVg==", r:3, c:7, d:"D", clue:"Deer meat found in Digest Care kibble and our Stool Regulator chunks", e:"(7)"},
  {a:"QUdFTU8=",     r:5, c:10,d:"D", clue:"Wild-Caught Marine ___: freeze-dried tuna, cod and egg yolk cubes", e:"(5)"},
  {a:"SVBPT0NT",     r:4, c:0, d:"D", clue:"Our measuring scoop: holds 150g of kibble and clips the bag shut", e:"(6)"}
];
const MAGIC = [[0,2],[8,0],[4,1],[6,7],[9,8],[1,4],[2,5],[1,9]];
const STORE = "notti-xword-v1";

WORDS.forEach(w => { w.ans = atob(w.a).split("").reverse().join(""); w.cells = [];
  for (let i=0;i<w.ans.length;i++) w.cells.push(w.d==="A" ? [w.r, w.c+i] : [w.r+i, w.c]); });

const sol = {}, entry = {}, cellWords = {};
const k = (r,c) => r+","+c;
WORDS.forEach(w => w.cells.forEach(([r,c],i) => { sol[k(r,c)] = w.ans[i]; (cellWords[k(r,c)] = cellWords[k(r,c)] || {})[w.d] = w; }));

let n = 0; const starts = {};
for (let r=0;r<ROWS;r++) for (let c=0;c<COLS;c++) {
  const here = WORDS.filter(w => w.r===r && w.c===c);
  if (here.length) { n++; starts[k(r,c)] = n; here.forEach(w => w.num = n); }
}
WORDS.sort((a,b) => a.num - b.num);

try {
  const stored = JSON.parse(localStorage.getItem(STORE) || "{}");
  if (stored && typeof stored === "object") {
    Object.keys(sol).forEach(key => { if (typeof stored[key] === "string" && /^[A-Z]$/.test(stored[key])) entry[key] = stored[key]; });
  }
} catch(e) {}
const save = () => { try { localStorage.setItem(STORE, JSON.stringify(entry)); } catch(e) {} };

const gridEl = $("grid"), els = {};
for (let r=0;r<ROWS;r++) for (let c=0;c<COLS;c++) {
  const d = document.createElement("div"), key = k(r,c);
  d.style.gridRow = String(r + 1);
  d.style.gridColumn = String(c + 1);
  d.dataset.row = String(r);
  d.dataset.col = String(c);
  if (sol[key]) {
    d.className = "nx-cell nx-on"; d.setAttribute("role","gridcell"); d.tabIndex = 0;
    d.setAttribute("aria-label", "Row " + (r+1) + ", column " + (c+1));
    d.addEventListener("keydown", e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); tap(r,c); } });
    if (starts[key]) d.innerHTML = '<span class="nx-num">' + starts[key] + '</span>';
    if (MAGIC.some(([mr,mc]) => mr===r && mc===c)) d.classList.add("nx-magic");
    d.insertAdjacentHTML("beforeend", '<span class="nx-ch"></span>');
    d.addEventListener("click", () => tap(r,c));
    els[key] = d;
  } else d.className = "nx-cell nx-blank";
  gridEl.appendChild(d);
}

const slotsEl = $("slots");
MAGIC.forEach(() => slotsEl.insertAdjacentHTML("beforeend", '<div class="nx-slot"><span></span></div>'));

const clueEls = new Map();
WORDS.forEach(w => {
  const li = document.createElement("li");
  li.className = "nx-clue"; li.tabIndex = 0;
  li.innerHTML = '<b>' + w.num + '</b><div><span>' + w.clue + '</span> <span class="nx-len">' + w.e + '</span></div>';
  li.addEventListener("click", () => { cur = { r:w.r, c:w.c, d:w.d }; render(); focusKb(); });
  li.addEventListener("keydown", e => { if (e.key==="Enter") li.click(); });
  $(w.d==="A"?"across":"down").appendChild(li);
  clueEls.set(w, li);
});

let cur = { r:4, c:0, d:"A" };
const kb = $("kb");
function focusKb(){ kb.focus({preventScroll:true}); }
function curWord(){ const cw = cellWords[k(cur.r,cur.c)]; return cw[cur.d] || cw.A || cw.D; }
function tap(r,c){
  const cw = cellWords[k(r,c)];
  if (cur.r===r && cur.c===c && cw.A && cw.D) cur.d = cur.d==="A" ? "D" : "A";
  else { cur.r=r; cur.c=c; if (!cw[cur.d]) cur.d = cw.A ? "A" : "D"; }
  render(); focusKb();
}
function step(dir){
  const w = curWord(); cur.d = w.d;
  const i = w.cells.findIndex(([r,c]) => r===cur.r && c===cur.c) + dir;
  if (i>=0 && i<w.cells.length) { cur.r = w.cells[i][0]; cur.c = w.cells[i][1]; }
}
function move(dr,dc){
  let r=cur.r+dr, c=cur.c+dc;
  while (r>=0 && r<ROWS && c>=0 && c<COLS) {
    if (sol[k(r,c)]) { cur.r=r; cur.c=c; const cw=cellWords[k(r,c)]; if (!cw[cur.d]) cur.d = cw.A?"A":"D"; return; }
    r+=dr; c+=dc;
  }
}
function type(ch){ entry[k(cur.r,cur.c)] = ch; clearMarks(); step(1); save(); render(); }
function back(){
  const key = k(cur.r,cur.c);
  if (entry[key]) delete entry[key]; else { step(-1); delete entry[k(cur.r,cur.c)]; }
  clearMarks(); save(); render();
}
kb.addEventListener("keydown", e => {
  const map = {ArrowLeft:[0,-1],ArrowRight:[0,1],ArrowUp:[-1,0],ArrowDown:[1,0]};
  if (map[e.key]) { e.preventDefault(); const dr=map[e.key][0], dc=map[e.key][1]; const nd = dc ? "A" : "D";
    const cw = cellWords[k(cur.r,cur.c)]; if (cur.d!==nd && cw[nd]) cur.d=nd; else move(dr,dc); render(); }
  else if (e.key==="Backspace" || e.key==="Delete") { e.preventDefault(); back(); }
  else if (e.key===" ") { e.preventDefault(); tap(cur.r,cur.c); }
  else if (e.key==="Tab") {
    const i = WORDS.indexOf(curWord()), next = i + (e.shiftKey ? -1 : 1);
    if (next >= 0 && next < WORDS.length) { e.preventDefault(); const w = WORDS[next]; cur={r:w.r,c:w.c,d:w.d}; render(); }
  }
  else if (/^[a-zA-Z]$/.test(e.key)) { e.preventDefault(); type(e.key.toUpperCase()); }
});
kb.addEventListener("beforeinput", e => {
  if (e.inputType === "deleteContentBackward" || e.inputType === "deleteContentForward") { e.preventDefault(); back(); }
});
kb.addEventListener("input", () => {
  const v = kb.value.replace(/[^a-zA-Z]/g,""); kb.value = "";
  if (v) type(v.slice(-1).toUpperCase());
});

let marked = false;
function clearMarks(){ if (marked) { Object.values(els).forEach(e => e.classList.remove("nx-wrong")); marked=false; $("status").textContent=""; } }

function render(){
  const w = curWord(), inWord = new Set(w.cells.map(([r,c]) => k(r,c)));
  for (const key in els) {
    const e = els[key];
    e.querySelector(".nx-ch").textContent = entry[key] || "";
    e.classList.toggle("nx-word", inWord.has(key));
    e.classList.toggle("nx-active", key===k(cur.r,cur.c));
  }
  clueEls.forEach((li, cw) => {
    li.classList.toggle("nx-active", cw===w);
    li.classList.toggle("nx-done", cw.cells.every(([r,c]) => entry[k(r,c)]));
  });
  const slots = slotsEl.querySelectorAll(".nx-slot");
  MAGIC.forEach(([r,c],i) => { const v = entry[k(r,c)]||""; slots[i].querySelector("span").textContent = v; slots[i].classList.toggle("nx-filled", !!v); });
  const solved = Object.keys(sol).every(key => entry[key]===sol[key]);
  $("magicbar").classList.toggle("nx-solved", solved);
  const win = $("win");
  if (solved && win.hidden) {
    win.hidden = false;
    $("pw").textContent = MAGIC.map(([r,c]) => sol[k(r,c)]).join("").toLowerCase();
    $("status").textContent = "Solved! Scroll down for your password.";
  } else if (!solved) win.hidden = true;
}

$("check").addEventListener("click", () => {
  let wrong=0, empty=0;
  for (const key in els) { const v = entry[key];
    if (!v) empty++; else if (v!==sol[key]) { wrong++; els[key].classList.add("nx-wrong"); } }
  marked = wrong>0;
  $("status").textContent =
    wrong ? wrong + (wrong>1 ? " squares are" : " square is") + " not right yet. They're crossed out." :
    empty ? "Everything so far is correct. " + empty + (empty>1 ? " squares" : " square") + " to go." : "All correct!";
});
let clearArmed = false;
$("clear").addEventListener("click", e => {
  const b = e.currentTarget;
  if (!clearArmed) { clearArmed = true; b.textContent = "Tap again to clear"; setTimeout(() => { clearArmed=false; b.textContent="Clear grid"; }, 3000); return; }
  for (const key in entry) delete entry[key]; clearArmed=false; b.textContent="Clear grid"; clearMarks(); save(); render();
});
$("copy").addEventListener("click", e => {
  const t = $("pw").textContent, b = e.currentTarget;
  const done = () => { b.textContent = "Copied"; setTimeout(() => b.textContent = "Copy password", 2000); };
  const fallback = () => { const s = window.getSelection(), rg = document.createRange(); rg.selectNodeContents($("pw")); s.removeAllRanges(); s.addRange(rg); b.textContent = "Selected, press copy"; };
  if (navigator.clipboard) navigator.clipboard.writeText(t).then(done, fallback); else fallback();
});

render();
}
document.querySelectorAll("[data-notti-crossword]").forEach(initNottiCrossword);
document.addEventListener("shopify:section:load", event => {
  event.target.querySelectorAll("[data-notti-crossword]").forEach(initNottiCrossword);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notti-review-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('notti-reviews-slider')) return;

    class NottiReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.announceTimer);
        clearInterval(this.autoplayTimer);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.ready = false;
      }

      initialize() {
        if (!this.isConnected || this.ready) return;

        this.track = this.querySelector('[data-nr-track]');
        this.cards = Array.from(this.querySelectorAll('[data-nr-card]'));

        if (!this.track || !this.cards.length) return;

        this.ready = true;
        this.dots = this.querySelector('[data-nr-dots]');
        this.controls = this.querySelector('[data-nr-controls]');
        this.previous = this.querySelector('[data-nr-prev]');
        this.next = this.querySelector('[data-nr-next]');
        this.status = this.querySelector('[data-nr-status]');
        this.events = new AbortController();

        const options = { signal: this.events.signal };

        this.points = [0];
        this.activePage = 0;
        this.autoplayDelay = 3500;

        this.cards.forEach((card, index) => {
          card.setAttribute(
            'aria-label',
            `Review ${index + 1} of ${this.cards.length}`
          );
        });

        this.previous.addEventListener('click', () => {
          this.goToPage(this.activePage - 1);
          this.restartAutoplay();
        }, options);

        this.next.addEventListener('click', () => {
          this.goToPage(this.activePage + 1);
          this.restartAutoplay();
        }, options);

        this.dots.addEventListener('click', (event) => {
          const button = event.target.closest('[data-nr-page]');

          if (button && this.dots.contains(button)) {
            this.goToPage(Number(button.dataset.nrPage));
            this.restartAutoplay();
          }
        }, options);

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);

          this.scrollFrame = requestAnimationFrame(() => this.update());

          clearTimeout(this.announceTimer);

          this.announceTimer = setTimeout(() => {
            if (this.points.length > 1 && this.status) {
              this.status.textContent =
                `Review page ${this.activePage + 1} of ${this.points.length}`;
            }
          }, 180);
        }, { ...options, passive: true });

        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;

          let page;

          if (event.key === 'ArrowRight') {
            page = this.activePage + (this.rtl ? -1 : 1);
          }

          if (event.key === 'ArrowLeft') {
            page = this.activePage + (this.rtl ? 1 : -1);
          }

          if (event.key === 'Home') page = 0;
          if (event.key === 'End') page = this.points.length - 1;

          if (page !== undefined) {
            event.preventDefault();
            this.goToPage(page);
            this.restartAutoplay();
          }
        }, options);

        this.addEventListener(
          'touchstart',
          () => this.stopAutoplay(),
          { ...options, passive: true }
        );

        this.addEventListener(
          'touchend',
          () => this.restartAutoplay(),
          { ...options, passive: true }
        );

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        }, options);

        document.addEventListener('shopify:block:select', (event) => {
          const selected = this.cards.find(
            (card) =>
              card.dataset.blockId === String(event.detail?.blockId)
          );

          if (selected) {
            this.scrollToPosition(this.cardOffset(selected), false);
          }
        }, options);

        const requestLayout = () => {
          cancelAnimationFrame(this.layoutFrame);
          this.layoutFrame = requestAnimationFrame(() => this.measure());
        };

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(requestLayout);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', requestLayout, options);
        }

        this.measure();
        this.dataset.enhanced = 'true';
        this.startAutoplay();
      }

      get position() {
        return Math.abs(this.track.scrollLeft);
      }

      cardOffset(card) {
        const first = this.cards[0].getBoundingClientRect();
        const current = card.getBoundingClientRect();

        return this.rtl
          ? first.right - current.right
          : current.left - first.left;
      }

      measure() {
        this.dataset.scrollable = 'true';

        const width = this.track.clientWidth;

        if (width < 1) return;

        const styles = getComputedStyle(this.track);
        this.rtl = styles.direction === 'rtl';

        const gap = parseFloat(styles.columnGap) || 0;
        const cardWidth = this.cards[0].getBoundingClientRect().width;

        this.maximum = Math.max(
          0,
          this.track.scrollWidth - width
        );

        /* One-card-at-a-time positions used only by autoplay. */
        this.autoplayPoints = [0];

        this.cards.slice(1).forEach((card) => {
          const position = Math.min(
            this.maximum,
            Math.max(0, this.cardOffset(card))
          );

          if (
            position - this.autoplayPoints[this.autoplayPoints.length - 1] > 2
          ) {
            this.autoplayPoints.push(position);
          }
        });

        if (
          this.maximum - this.autoplayPoints[this.autoplayPoints.length - 1] > 2
        ) {
          this.autoplayPoints.push(this.maximum);
        }

        const perPage = Math.max(
          1,
          Math.floor((width + gap + 2) / (cardWidth + gap))
        );

        this.points = [0];

        for (
          let index = perPage;
          index < this.cards.length;
          index += perPage
        ) {
          const position = Math.min(
            this.maximum,
            Math.max(0, this.cardOffset(this.cards[index]))
          );

          if (
            position - this.points[this.points.length - 1] > 2
          ) {
            this.points.push(position);
          }
        }

        if (
          this.maximum - this.points[this.points.length - 1] > 2
        ) {
          this.points.push(this.maximum);
        }

        const signature = `${this.points.length}:${perPage}`;

        if (signature !== this.dotSignature) {
          const focusIndex = this.dots.contains(document.activeElement)
            ? Number(document.activeElement.dataset.nrPage)
            : null;

          this.dots.replaceChildren();

          this.points.forEach((_, index) => {
            const button = document.createElement('button');

            button.type = 'button';
            button.className = 'nr__dot';
            button.dataset.nrPage = String(index);
            button.setAttribute(
              'aria-label',
              `Go to review page ${index + 1}`
            );
            button.setAttribute(
              'aria-controls',
              this.track.id
            );

            this.dots.appendChild(button);
          });

          if (focusIndex !== null) {
            this.dots.children[
              Math.min(focusIndex, this.points.length - 1)
            ]?.focus({ preventScroll: true });
          }

          this.dotSignature = signature;
        }

        this.dataset.scrollable = String(this.maximum > 2);

        this.controls.hidden =
          this.points.length < 2 ||
          (this.previous.hidden && this.dots.hidden);

        this.update();
      }

      update() {
        const current = this.position;
        let nearest = 0;

        this.points.forEach((point, index) => {
          if (
            Math.abs(point - current) <
            Math.abs(this.points[nearest] - current)
          ) {
            nearest = index;
          }
        });

        this.activePage = nearest;

        this.dots
          .querySelectorAll('[data-nr-page]')
          .forEach((button, index) => {
            if (index === nearest) {
              button.setAttribute('aria-current', 'true');
            } else {
              button.removeAttribute('aria-current');
            }
          });

        this.previous.disabled = current <= 2;
        this.next.disabled = current >= this.maximum - 2;
      }

      scrollToPosition(position, animate = true) {
        const target = Math.max(
          0,
          Math.min(this.maximum, position)
        );

        const reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.track.scrollTo({
          left: this.rtl ? -target : target,
          behavior:
            animate && !reduceMotion ? 'smooth' : 'instant'
        });
      }

      goToPage(index) {
        const page = Math.max(
          0,
          Math.min(this.points.length - 1, index)
        );

        this.scrollToPosition(this.points[page]);
      }

      startAutoplay() {
        this.stopAutoplay();

        if (!this.autoplayPoints || this.autoplayPoints.length < 2 || document.hidden) return;

        this.autoplayTimer = setInterval(() => {
          const current = this.position;
          let currentIndex = 0;

          this.autoplayPoints.forEach((point, index) => {
            if (
              Math.abs(point - current) <
              Math.abs(this.autoplayPoints[currentIndex] - current)
            ) {
              currentIndex = index;
            }
          });

          const nextIndex =
            currentIndex >= this.autoplayPoints.length - 1
              ? 0
              : currentIndex + 1;

          this.scrollToPosition(this.autoplayPoints[nextIndex]);
        }, this.autoplayDelay);
      }

      stopAutoplay() {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    customElements.define(
      'notti-reviews-slider',
      NottiReviewsSlider
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
